import { indexOf } from "lodash"

export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

export const isArray = (arg: any) => {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export const isValidURL = (url: string) => {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

export const chineseVerification = (val: string) => {
  let res
  const reg = /^[~@#&*——、，。？！……《》￥$%（）}{+-×÷=<>_/a-zA-Z0-9]*$/
  if(reg.test(val)){
     res = val
  }else {
   let spaceReg = /\s+/g
   if(spaceReg.test(val)){
    let a = val.replace(/\s+/g,'')
    res = a.replace(/[^\x00-\xff]/gi,'')
   }else {
    res = val.replace(/[^\x00-\xff]/gi,'')
   }
  }
  return res
}

export const inputRules = (val: string) => {
  let res
  const reg = /^[~@#&*——、，。？！……《》 ￥$%（）}{+-×÷=<>_/a-zA-Z0-9\u4E00-\u9FA5\u0800-\u4e00\uac00-\ud7ff]*$/
  if(reg.test(val)){
     res = val
  }else {
    res = val.replace(/[^\x00-\xff]/gi,'')
  }
  return res
}

export const inputLengthLimit = (val: string,maxLength:any) => {
  let b = 0; // 输入的字符数
  for (let i = 0, length = val.length; i < length; i++) {
    let c = val.charAt(i);
    if (/^[\u0000-\u00ff]$/.test(c)) {
      b++;
    } else {
      b += 2;
    }
    if (b > maxLength) {
      val = val.slice(0 ,val.length-1);
      if (/^[\u0000-\u00ff]$/.test(c)) {
        b--;
      } else {
        b -= 2;
      }
    }
  }
  return val
}